// extracted by mini-css-extract-plugin
module.exports = {"inline-buttons":"InlineButtons_inline-buttons__QIYAe"};